import { createFileRoute, Link, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sample/products')({
  component: () => (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div
        style={{
          padding: '15px',
          background: '#e8f8e8',
          borderRadius: '8px',
          marginBottom: '20px',
          border: '2px solid #4caf50',
        }}
      >
        <h1 style={{ marginBottom: '10px', color: '#333' }}>Products Layout</h1>
        <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
          Products 관련 페이지들의 공통 레이아웃입니다. Nested vs Non-Nested
          차이를 비교할 수 있습니다.
        </p>
        <nav>
          <Link to="/" style={{ marginRight: '10px', color: '#4caf50' }}>
            ← 홈으로
          </Link>
          <span style={{ margin: '0 5px', color: '#999' }}>|</span>
          <Link
            to="/products"
            style={{ marginRight: '10px', color: '#4caf50' }}
          >
            Products Index
          </Link>
          <span style={{ margin: '0 5px', color: '#999' }}>|</span>
          <Link
            to="/products/123"
            style={{ marginRight: '10px', color: '#4caf50' }}
          >
            Product 123 (Nested)
          </Link>
          <span style={{ margin: '0 5px', color: '#999' }}>|</span>
          <Link to="/products/456/detail" style={{ color: '#4caf50' }}>
            Product 456 Detail (Non-Nested)
          </Link>
        </nav>
      </div>
      <div
        style={{
          padding: '20px',
          background: '#f9f9f9',
          borderRadius: '8px',
          border: '2px dashed #4caf50',
        }}
      >
        <div style={{ fontSize: '12px', color: '#999', marginBottom: '10px' }}>
          ↓ 자식 라우트 영역 (Outlet) ↓
        </div>
        <Outlet />
      </div>
    </div>
  ),
});
